// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// TODO MOVER TUDO ISSO PRA ALGUM ARQUIVO E UNIFICAR COM OS UTILS
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@


export function copyToClipBoard(text: string) {
  var temp = document.createElement('textarea');
  temp.value = text;
  document.body.appendChild(temp);
  var intervaloSelecao = document.createRange();
  intervaloSelecao.selectNode(temp);
  window.getSelection()?.removeAllRanges();
  window.getSelection()?.addRange(intervaloSelecao);
  document.execCommand('copy');
  document.body.removeChild(temp);
}


export function censorEmail(email:string){
  if(!email)return;
  const atIndex = email.indexOf('@');
  if (atIndex > 0) {
    let splitIndex = atIndex == 1 ? 0 : atIndex-(atIndex-1)    
    const visiblePart = email.substring(0, splitIndex); 
    const censoredPart = '*'.repeat(atIndex - splitIndex);
    return `${visiblePart}${censoredPart}${email.substring(atIndex)}`;
  }
  return email;
};

export const censorEmailsInDescription = (description:string) => {
  if(!description)return;
  
  // Detecta links em formato Markdown [texto](url)
  const markdownLinkRegex = /\[([^\]]+)\]\(([^)]+)\)/gi;
  let censoredDescription = description.replace(markdownLinkRegex, '(Link oculto)');
  
  // Detecta links soltos (apenas com http, https ou www)
  const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)/gi;
  censoredDescription = censoredDescription.replace(urlRegex, '(Link oculto)');
  
  // Depois censura os emails
  const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;
  censoredDescription = censoredDescription.replace(emailRegex, (match) => {
    const atIndex = match.indexOf('@');
    let splitIndex = atIndex == 1 ? 0 : atIndex-(atIndex-1)
    const visiblePart = match.substring(0, splitIndex); 
    const censoredPart = '*'.repeat(atIndex - splitIndex);
    return `${visiblePart}${censoredPart}${match.substring(atIndex)}`;
  });
  
  return censoredDescription;
};

export const verifyItemIsImage = (link: string): boolean => {
  return /\.(png|jpe?g|gif|webp)$/i.test(link) || link.includes("base64");
};

export const verifyIsVideo = (link: string): boolean => {
  return /\.(mp4)$/i.test(link);
};

export const verifyIdPdf = (link: string): boolean => {
  return /\.(pdf)$/i.test(link);
};

export const verifyIsByteImage = (link: string):boolean => {
  return link.includes("/9j/") || link.includes("/iVBORw0KGgo/") || link.includes("/R0lGOD/");
}

export function extrairNomeArquivo(url:string) {
  // const padrao = /https:\/\/files\.aprendaerp\.com\.br\.s3[^/]*\/([^/]+)$/;
  // const correspondencias = url.match(padrao);
  if (url.includes("files2.aprendaerp.com.br")) {
    var splited = url.split("/");

    return splited[splited.length - 1]
      .replace(".png", "")
      .replace(".jpeg", "")
      .replace(".jpg", "")
      .replace(".pdf", "")
      .replace(".xml", "");
  } else {      
    return url;
  }
}

